import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "../../../../../../utilities/i18n";
import { AddCartNonPricedProductFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";

export interface PriceFormInputProps {}

export const PriceFormInput = ({}: PriceFormInputProps) => {
  const { control } = useFormContext<AddCartNonPricedProductFormValues>();
  const { t } = useTranslation("pos");

  return (
    <View>
      <Label required label={t("form.price.label")}></Label>
      <Controller
        name="price"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onChangeText={onChange}
            onBlur={onBlur}
            value={value ?? ""}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.price.placeholder")}
            formatterType={error?.message ? undefined : "money"}
          />
        )}
      />
    </View>
  );
};
